import { Component, OnInit, Renderer } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { AccessControlService } from 'src/app/services/access-control.service';
import { CheckPermissionService } from 'src/app/services/check-permission.service';
import { AuthService } from 'src/app/services/auth.service';
// declare var $: any
@Component({
  selector: 'app-system-user-listing',
  templateUrl: './system-user-listing.component.html',
  styleUrls: ['./system-user-listing.component.css']
})
export class SystemUserListingComponent implements OnInit {

  userList: any = [];
  is_add: boolean = false;
  static is_edit: boolean = false;
  static is_delete: boolean = false;
  static app_id: any;
  application: any = [];
  application_name: any;
  app_code: any;
  clientId:any;
  constructor(private renderer: Renderer,
    private router: Router,
    private authService: AuthService,
    private accessControlService: AccessControlService,
    private checkPermissionService: CheckPermissionService,
    private activatedRoute: ActivatedRoute) {
    SystemUserListingComponent.app_id = this.activatedRoute.snapshot.params['id'];
    this.app_code = this.activatedRoute.snapshot.queryParamMap.get('opt')
  }

  ngOnInit() {
    this.is_add = this.checkPermissionService.getAction('add');
    SystemUserListingComponent.is_edit = this.checkPermissionService.getAction('edit');
    SystemUserListingComponent.is_delete = this.checkPermissionService.getAction('delete');
    this.accessControlService.getRoute.next(true)
    localStorage.setItem('option', 'setting');
    this.clientId=localStorage.getItem("org_id")
    this.listallUsers_within_App();
    this.getapplicationbyId();
  }


  getapplicationbyId() {
    this.accessControlService.getapplicationbyId(SystemUserListingComponent.app_id).subscribe((res) => {
      this.application = res;
      this.application_name = this.application.application_name;
    }, error => {
      //console.log(error)
    },
      () => {

      })
  }
  listallUsers_within_App() {
    this.authService.listallUsers_within_App(SystemUserListingComponent.app_id).subscribe((res) => {
      this.userList = res;
    }, error => {

    }, () => {
    })
  }


  addRoute() {
    this.router.navigate(['add-system-user'], { queryParams: { opt: 'add', app_id: SystemUserListingComponent.app_id } });
  }
  verify(action: any) {
    Swal({
      title: 'Are you sure you want delete?',
      text: "You won't be able to revert this!",
      type: 'warning',
      width: '30%',
      showCancelButton: true,
      confirmButtonColor: 'text-danger',
     cancelButtonColor: '#f8ac59',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {
        Swal(
          'Deleted!',
          'User has been deleted.',
          'success'
        ).then(() => {
          // this should execute now
          this.authService.deleteUser(action,this.clientId,{orginalClient:true}).subscribe((res) => {
          }, error => { },
            () => {
              this.listallUsers_within_App();
            })
        });
      }

    })
  }

  ngAfterViewInit(): void {
    this.renderer.listenGlobal('document', 'click', (event) => {
      if (event.target.hasAttribute('method-action')) {
        var action = event.target.getAttribute("method-action");
        this.verify(action)
      }
      if (event.target.hasAttribute('data-action')) {
        var action = event.target.getAttribute("data-action");
        this.router.navigate([action]);
      }
    });
  }
}
